import styled from '@emotion/styled';
import { css } from '@emotion/react';

const BORDER_RADIUS = '4px';
const BORDER = '1px solid #bbb';
const OPEN_GRADIENT = 'linear-gradient(#eee 20%, #fff 80%)';
const CLOSED_GRADIENT =
  'linear-gradient(#fff 20%, #f6f6f6 50%, #eee 52%, #f4f4f4 100%)';

const activeOption = css`
  background: #3875d7;
  color: #fff;
  background-image: linear-gradient(#3875d7 20%, #2a62bc 90%);
`;

export const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const DropdownFilterStyled = styled.button`
  position: relative;
  width: 100%;
  height: 28px;
  padding: 0.21rem 1.07rem;
  overflow-y: visible;
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  align-items: center;
  background: transparent;
  background-image: ${({ isOpen }) =>
    isOpen ? OPEN_GRADIENT : CLOSED_GRADIENT};

  border: ${BORDER};
  border-bottom: ${({ isOpen }) => (isOpen ? 'none' : BORDER)};
  border-radius: ${({ isOpen }) =>
    isOpen ? `${BORDER_RADIUS} ${BORDER_RADIUS} 0 0` : BORDER_RADIUS};

  & > span {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1rem;
    font-family: ${({ theme }) => theme.fonts.default};
  }
`;

export const CaretIcon = styled.b`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.45rem;
  border-top: 0.38rem solid;
  border-right: 0.38rem solid transparent;
  border-left: 0.38rem solid transparent;
  opacity: 0.7;
`;

export const Menu = styled.div`
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  transform: translateY(100%);
  background: #fff;
  z-index: 1000;
  overflow-y: auto;
  border: ${BORDER};
  border-top: none;
  border-radius: 0 0 ${BORDER_RADIUS} ${BORDER_RADIUS};
`;

export const FilterWrapper = styled.div`
  width: 100%;
  width: -moz-available;
  width: -webkit-fill-available;
  width: fill-available;
  margin: 0.35rem;
  display: flex;

  input {
    height: 28px;
    width: 100%;
    padding-left: 0.29rem;

    &::placeholder {
      font-size: 1rem;
    }
  }
`;

export const Options = styled.div`
  max-height: 240px;
  overflow: auto;
`;

export const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  svg {
    width: 1rem;
    cursor: pointer;
    stroke: #444;
    stroke-width: 0.3rem;
    margin: 0.3rem;
    position: absolute;
    right: 0;
  }
`;

export const OptionText = styled.div`
  width: 100%;
  cursor: pointer;
  color: ${({ selected, theme }) =>
    selected ? theme.colors.textLight : theme.colors.textDark};
  background: ${({ selected }) => (selected ? '#428bca' : 'none')};
  align-items: center;
  padding: 0.71rem;
  margin-right: ${({ removable }) => (removable ? '1.5rem' : 0)};
  word-break: break-word;

  ${({ selected }) => (selected ? activeOption : '')};

  &:hover {
    ${activeOption}
  }
`;
